import { forwardRef } from 'react';

const VARIANTI = {
  primary: 'bg-brand-700 text-white hover:bg-brand-600 disabled:bg-brand-700/50',
  secondary: 'bg-surface text-ink border border-line hover:bg-surface-2',
  ghost: 'text-ink hover:bg-surface-2',
  danger: 'bg-danger text-white hover:bg-danger/90',
  'danger-ghost': 'text-danger hover:bg-danger-bg',
};
const MISURE = {
  // 44px di area toccabile anche sulla misura piccola
  sm: 'min-h-[36px] px-3 text-sm gap-1.5',
  md: 'min-h-[44px] px-4 text-sm gap-2',
};

const Button = forwardRef(function Button(
  { variant = 'secondary', size = 'md', loading = false, icon: Icon, className = '',
    disabled, children, type = 'button', ...resto }, ref) {
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      aria-busy={loading || undefined}
      className={`inline-flex items-center justify-center rounded font-medium transition-colors
        disabled:opacity-60 ${VARIANTI[variant]} ${MISURE[size]} ${className}`}
      {...resto}
    >
      {loading
        ? <span aria-hidden className="h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent" />
        : Icon && <Icon size={size === 'sm' ? 16 : 18} aria-hidden />}
      {children}
    </button>
  );
});

export default Button;
